import {Customer, IItemContent} from "../../../typescript-library";
import {PaDataType, retrieveInternalResult} from "./retrievalHelper";
import {ItemContainerKeyType, ItemContainerType} from "./LazyCrossSelling";

export let boughtTogetherCache: IItemContent[] | undefined;

export async function itemsOptimizer(
  paResults: PaDataType[],
  customer: Customer,
  seriesItemContent: IItemContent[],
): Promise<ItemContainerType> {
  // Only take results, where the payload exists
  const filteredPaResults = paResults.filter((result) => {
    if (!result.paReturn.payload?.length) {
      // Show a message if no payload given
      if (__DEVELOPMENT__) {
        const {paReturn, paUrl} = result;

        // eslint-disable-next-line no-console
        console.log(`DEVELOP: No PA response payload on '${paUrl}':`, paReturn);
      }

      return false;
    } else {
      return result.paReturn.payload.length >= 4;
    }
  });

  // From every result only take the payload
  const reducedItemIds = filteredPaResults.map((result) => {
    // Only take the first 32 results. On 8x4 CrossSellings (Including
    // series and collections) every CS has the chance to show 8 products
    result.paReturn.payload = result.paReturn.payload?.slice(0, 24 + seriesItemContent.length) || [];

    return result.paReturn.payload;
  });

  // Concat `string[][]` to `string[]`
  const concatArray = ([] as string[]).concat(...reducedItemIds);

  // Reduce to distinct itemIds
  const seriesItemIds = seriesItemContent.map((id) => String(id.itemId));
  const distinctItemIds = Array.from(new Set(concatArray)).filter((id) => !seriesItemIds.includes(id));

  // Retrieve data from internal GSS api
  const internalApiResponse = await retrieveInternalResult(distinctItemIds, customer);

  const finalStateObject: ItemContainerType = {};
  filteredPaResults.forEach((filtered) => {
    filtered.paReturn.payload?.forEach((paItemId) => {
      if ((finalStateObject[filtered.namespace]?.length || 0) >= 8) {
        return;
      }
      const internalItemIndex = internalApiResponse.result.findIndex(
        (internal) => String(internal.itemId) === paItemId,
      );
      if (internalItemIndex > -1) {
        if (!Array.isArray(finalStateObject[filtered.namespace])) {
          finalStateObject[filtered.namespace] = [];
        }
        finalStateObject[filtered.namespace]?.push(...internalApiResponse.result.splice(internalItemIndex, 1));
      }
    });
  });
  const stateKeys = Object.keys(finalStateObject);
  stateKeys.forEach((sk: ItemContainerKeyType) => {
    if ((finalStateObject as Required<ItemContainerType>)[sk].length < 4) {
      delete finalStateObject[sk];
    }
  });
  if (finalStateObject.boughtTogether) {
    boughtTogetherCache = finalStateObject.boughtTogether;
  }

  return finalStateObject;
}
